import React from "react";



export default function Input({ value, setValue,label,type}) {

    return (
        <div className="mb-3">
            <label className="form-label">{label}</label>
            <input value={value} onChange={e => setValue(e.target.value)} type={type} className="form-control"  />
        </div>
    )

} 
